import {Row, Col, useIsMobile} from './Flexbox'
import Logo from './Logo';
import NavTab from "./NavTab";
import NavLink from "./NavLink";
import FilterBar from "./FilterBar";
import subTabs from "../constants/NavigationSubTabs";
import { useAuth } from '../scripts/functions/AuthProvider';
import { signOutLink } from '../scripts/functions/AuthService';
import DarkModeSharpIcon from '@mui/icons-material/DarkModeSharp';

const TABS = [
    {id: 'produccion', text: 'Producción', path: 'produccion', subpath: 'dashboard', access: 'produccion'},
    {id: 'ventas', text: 'Ventas', path: 'ventas', subpath: 'forecast', access: 'ventas'},
    {id: 'compras', text: 'Compras', path: 'compras', subpath: 'necesidadcompra', access: 'compras'},
    {id: 'recursoshumanos', text: 'Recursos Humanos', path: 'recursoshumanos', subpath: 'rh', access: 'recursos humanos'},
    {id: 'administracion', text: 'Admin', path: 'administracion', subpath: 'acceso', access: 'admin'},
]

export const TopBar = props => {

    const isMobile = useIsMobile();
    const {userClaims} = useAuth();
    const location = props.path.split("/")[1] ? props.path.split("/")[1] : "login"

    const hasAccess = (requiredDept) => {
        const depts = userClaims?.departments || [];
        const groups = userClaims?.groups || [];
        const actions = userClaims?.actions || [];

        if (groups.includes("superadmin") || actions.includes("*")) {
            return true
        }

        if (depts.includes(requiredDept)) {
            return true;
        }

        return false;
    }

    const logout = async () => {
        await signOutLink();
        window.location.reload();
    }
    return (
        <Row style={{
            height: '180px',
            padding: 64,
            boxShadow: props.isDark ? '0px 4px 8px rgba(0,0,0, 0.15)' : '0px 2px 15px rgba(0,0,0,0.05)',
            flex: 'none',
            width:'100%'
          }}>
            <Col style={{ flex: 'none'}}>
              <Logo height={isMobile ? 84 : 116} width={isMobile ? 84 : 116}/>
            </Col>
            <Col style={{flex:1, width:'100%', justifyContent:'space-between', height:120}}>
                <FilterBar style={{flex: 1, marginLeft: 54, marginRight: 13, justifyContent:'flex-start', width:'100%', gap: 16 }}>
                    {TABS.map(tab => (
                        hasAccess(tab.access) && (
                            <NavTab
                                key={tab.id}
                                theme={props.theme}
                                navigate={props.navigate}
                                text={tab.text}
                                active={props.path.includes(tab.path)}
                                location={`/${tab.path}/${tab.subpath}`}/> 
                        )
                    ))}

                    <Row style={{alignItems: 'center', flex: 1, justifyContent: 'end', gap: 16, marginLeft: isMobile ? 16 : 'auto'}}>
                        <Col style={{flex:'none'}}>
                            <span style={{fontSize: 15, color:props.theme.Magenta, cursor:'pointer'}} onClick={logout}>Cerrar Sesión</span>
                        </Col>
                        <div onClick={props.toggleTheme} style={{ right: '20px',cursor: 'pointer', display: 'flex', height: '35px', width: '35px', borderRadius: '50%', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
                            <DarkModeSharpIcon style={{color: props.theme.Black, display: 'block', fontSize: '30px'}} titleAccess='Cambiar tema'/>
                        </div>
                    </Row>
                </FilterBar>
                <FilterBar style={{flex: 1, marginLeft: 54, marginRight: 1,width:'100%', justifyContent:'flex-start', flexWrap: 'nowrap'}}>
                    {(subTabs[location] || []).map(tab => 
                        <NavLink
                            text={tab.label}
                            navigate={props.navigate}
                            theme={props.theme}
                            location={`/${props.path.split("/")[1]}/${tab.path}`}
                            active={props.path.includes(`/${tab.path}`)}/>)}
                </FilterBar>
            </Col>                        
        </Row>
    )
}